import * as React from 'react';
import { IconProps } from '../types';

const IcEmail = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M4 3a1.5 1.5 0 0 0-1.5 1.5v15A1.5 1.5 0 0 0 4 21h17a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 21 3H4Zm.5 16V5h16v14h-16ZM6.57 7.678l5.93 4.106 5.93-4.106 1.14 1.644-6.216 4.303a1.5 1.5 0 0 1-1.708 0L5.431 9.322l1.138-1.644Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcEmail;
